import React from "react";
import { useTrades } from "newui/features/Company/hooks/useTrades";
import {
	SelectWithLabel,
	BaseSelectWithLabelProps,
	SelectOption,
} from "../InputWithLabel/SelectWithLabel";
import { useFormikFieldState } from "./useFormikField";

interface TradeSelectProps
	extends Omit<BaseSelectWithLabelProps, "options" | "isLoading"> {
	selectedIds?: number[];
}

export const TradeSelect: React.FC<TradeSelectProps> = ({
	label = "Trades",
	placeholder = "Select trades",
	selectedIds,
	value: valueProp,
	hasError: hasErrorProp,
	errorText: errorTextProp,
	onChange: onChangeProp,
	name,
	...rest
}) => {
	const { values, isLoading } = useTrades();
	const formik = useFormikFieldState(name);

	const resolvedValue = selectedIds
		? isLoading
			? undefined
			: selectedIds
				.map((id) => values.find((t) => t.value === id))
				.filter(Boolean) as SelectOption[]
		: valueProp;

	const handleChange = (selected: SelectOption | SelectOption[] | null) => {
		formik.markTouched();
		onChangeProp?.(selected);
	};

	return (
		<SelectWithLabel
			options={values as SelectOption[]}
			isLoading={isLoading}
			isMulti
			label={label}
			placeholder={placeholder}
			value={resolvedValue}
			name={name}
			hasError={hasErrorProp || formik.hasError}
			errorText={errorTextProp || formik.errorText}
			onChange={handleChange}
			{...rest}
		/>
	);
};
